module.exports = __webpack_public_path__ + "img/Background4.561b6b5a.png";